import { useNavigate } from "react-router-dom";
import useFlow from "../hooks/useFlow";
import { useEffect, useState } from "react";
import EventsOverlay from "../components/EventsOverlay";
import SettingsGear from "../components/SettingsGear";

export default function Home() {
  const navigate = useNavigate();
  const { locationPreferences, openRegisterModal } = useFlow();
  const [locationData, setLocationData] = useState(null);

  useEffect(() => {
    setLocationData(locationPreferences);
  }, [locationPreferences]);

  const itens = [
    {
      name: "Class",
      sub: "check-in",
      action: () => navigate("./class"),
    },
    {
      name: "Event",
      sub: "check-in",
      action: () => navigate("./event"),
    },
    {
      name: "Purchase",
      sub: "product",
      action: () => navigate("./store"),
    },
  ];
  return (
    <>
      {locationData?.homeEvents && <EventsOverlay />}
      <div
        className="container-fluid d-flex align-items-center justify-content-center p-0"
        id="welcome-page"
        style={{ minHeight: "100vh" }}
      >
        <div className="w-100 text-center welcome-actions" id="starter">
          {locationData?.logo && (
            <div id="welcome-logo">
              <img
                src={locationData.logo}
                className="img-fluid"
                style={{ maxWidth: "200px" }}
                alt="Logo"
              />
            </div>
          )}

          <div className="mb-5" id="welcome-heading">
            <h1 className="display-4 fw-lighter lh-1 m-0" id="welcome-title">
              {locationData?.title || "Welcome!"}
            </h1>
            <h2
              className="display-1 fw-bold lh-1 text-dark m-0"
              id="welcome-subtitle"
            >
              {locationData?.subTitle || "Start here"}
            </h2>
          </div>

          {/* Horizontal gutters only — the stacked-card gap comes from mb-4 on
              the columns, so the row keeps a clean box. */}
          <div
            className="row justify-content-center gx-4 gy-0 py-5"
            id="checkin-cards"
          >
            {itens.map((item, index) => (
              <div
                className="col-12 col-md-4 col-lg-3 mb-4 mb-md-0 checkin-card-col"
                id={`checkin-card-${item.name.toLowerCase()}`}
                key={index}
              >
                <div className="card shadow-sm rounded-4 border checkin-card">
                  <div
                    className="card-body d-flex flex-column justify-content-center align-items-center text-center py-5"
                    role="button"
                    data-testid={`home-${item.name.toLowerCase()}-card`}
                    onClick={item.action}
                  >
                    <h3 className="fw-bold mb-0 fs-2 checkin-card-title">
                      {item.name}
                    </h3>
                    <p className="fw-light mb-0 fs-4 checkin-card-sub">
                      {item.sub}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5" id="signup-row">
            <a
              className="sign-up-modal btn btn-outline-secondary btn-lg opacity-50"
              id="sign-up"
              data-testid="home-signup-btn"
              onClick={() => openRegisterModal()}
            >
              Create an account
            </a>
          </div>
        </div>
        <SettingsGear />
      </div>
    </>
  );
}
